import { render, staticRenderFns } from "./LegistlativeTypeSelector.vue?vue&type=template&id=3151502c"
import script from "./LegistlativeTypeSelector.vue?vue&type=script&lang=js"
export * from "./LegistlativeTypeSelector.vue?vue&type=script&lang=js"
import style0 from "./LegistlativeTypeSelector.vue?vue&type=style&index=0&id=3151502c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports